var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1112_89783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40C31.0457 40 40 31.0457 40 20Z",
    fill: "#F56565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 36C28.7868 36 35.91 28.8366 35.91 20C35.91 11.1634 28.7868 4 20 4C11.2131 4 4.08997 11.1634 4.08997 20C4.08997 28.8366 11.2131 36 20 36Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 34.84C28.1517 34.84 34.76 28.1959 34.76 20C34.76 11.8041 28.1517 5.16 20 5.16C11.8483 5.16 5.23999 11.8041 5.23999 20C5.23999 28.1959 11.8483 34.84 20 34.84Z",
    fill: "#FEB2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 5.74C27.83 5.74 34.18 12.13 34.18 20.01C34.18 27.89 27.83 34.28 20 34.28C12.17 34.28 5.82004 27.89 5.82004 20.01C5.82004 12.13 12.17 5.74 20 5.74ZM20 4.58C11.54 4.58 4.67004 11.5 4.67004 20C4.67004 28.5 11.55 35.42 20 35.42C28.45 35.42 35.33 28.5 35.33 20C35.33 11.5 28.45 4.58 20 4.58Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 7.49C27.5399 7.49 33.6999 13.41 34.1499 20.88C34.1699 20.59 34.1799 20.3 34.1799 20C34.1799 12.12 27.8299 5.73 19.9999 5.73C12.1699 5.73 5.81995 12.12 5.81995 20C5.81995 20.29 5.82995 20.59 5.84995 20.88C6.29995 13.41 12.4599 7.49 19.9999 7.49Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.01 27.36C24.62 27.36 24.23 27.21 23.94 26.91L13.92 16.82C13.33 16.22 13.33 15.26 13.92 14.66C14.51 14.06 15.47 14.06 16.07 14.66L26.09 24.75C26.68 25.35 26.68 26.31 26.09 26.91C25.79 27.21 25.41 27.36 25.02 27.36H25.01Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.99 27.36C14.6 27.36 14.21 27.21 13.92 26.91C13.33 26.31 13.33 25.35 13.92 24.75L23.94 14.66C24.53 14.06 25.49 14.06 26.09 14.66C26.68 15.26 26.68 16.22 26.09 16.82L16.07 26.91C15.77 27.21 15.39 27.36 15 27.36H14.99Z",
    fill: "#171923"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1112_89783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModal);
export default __webpack_public_path__ + "static/media/DeleteModal.6ec141f3b1a38a17cb6644aa1e5865c6.svg";
export { ForwardRef as ReactComponent };